<template>
  <a-card :bordered="false">
    <div>
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="日期">
                <a-range-picker @change="time" format="YYYY-MM-DD" style="width: 100%">
                  <template slot="dateRender" slot-scope="current">
                    <div class="ant-calendar-date" :style="getCurrentStyle(current)">
                      {{ current.date() }}
                    </div>
                  </template>
                </a-range-picker>
              </a-form-item>
            </a-col>
            <a-col :md="2" :sm="24">
              <a-button type="primary" icon="search" @click="loadStatisticsData">查询</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table
        ref="table"
        size="small"
        rowKey="id"
        :loading="loading"
        :columns="columns"
        :data-source="dataSource"
        :pagination="false"
      >
        <span slot="serial" slot-scope="text, record, index">
          {{ index + 1 }}
        </span>
        <span slot="image" slot-scope="img">
          <a-avatar
            slot="img"
            :src="img"
            shape="square"
            @click="openPreview(img)"
          />
        </span>
        <div slot="money_render" slot-scope="text" style="text-align: right; width: 150px">
          {{ (text / 100).toFixed(2) | numberFormat }}
        </div>
        <template slot="footer" v-if="totalData">
          <span style="padding-left: 20px">入库数量：{{ totalData.total_in_count }}</span>
          <span style="padding-left: 20px">出库数量：{{ totalData.total_out_count }}</span>
          <span style="padding-left: 20px">费用总计：{{ (totalData.total_fee / 100).toFixed(2) | numberFormat }}</span>
        </template>
      </a-table>
      <a-modal v-model="previewVisible" title="预览" width="450px" :footer="null">
        <img alt="example" style="width: 400px; margin: 0 auto" :src="previewUrl" />
      </a-modal>
    </div>
  </a-card>
</template>

<script>
import { STable } from '@/components'
import { Dictionaries } from '@/common/AllConstant'
import { monitor_plane_statistics } from '@/api/monitor_plane'

export default {
  name: 'TableList',
  components: {
    STable
  },
  data () {
    return {
      totalData: undefined,
      dataSource: [],
      loading: false,
      confirmLoading: false,
      dictionaries: Dictionaries,
      previewUrl: '',
      previewVisible: false,
      // 创建窗口控制
      visible: false,
      mdl: {},
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          fixed: 'left',
          title: '序号',
          width: 50,
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '日期',
          dataIndex: 'date',
          width: 200,
          ellipsis: true
        },
        {
          title: '入数量',
          dataIndex: 'in_count',
          width: 150,
          ellipsis: true
        },
        {
          title: '出数量',
          dataIndex: 'out_count',
          width: 150,
          ellipsis: true
        },
        {
          title: '费用',
          dataIndex: 'daily_fee',
          width: 150,
          align: 'center',
          ellipsis: true,
          scopedSlots: { customRender: 'money_render' }
        }
      ]
    }
  },
  created () {
    this.setCurrentPage()
  },
  mounted () {
    // this.loadStatisticsData()
  },
  methods: {
    time (dates, dateStrings) {
      console.log(dateStrings, '时间')
      this.queryParam.start_time = dateStrings[0] + ' 00:00:01'
      this.queryParam.end_time = dateStrings[1] + ' 23:59:59'
    },
    getCurrentStyle (current, today) {
      const style = {}
      if (current.date() === 1) {
        style.border = '1px solid #1890ff'
        style.borderRadius = '50%'
      }
      return style
    },
    loadStatisticsData () {
      monitor_plane_statistics(this.queryParam)
        .then(res => {
          console.log(res.data, '我是数据列表@')
          this.dataSource = res.data.daily
          this.totalData = res.data.total
        })
    },
    chooseMonthOk (date, dateString) {
      if (dateString === '') {
        this.queryParam.date = undefined
      } else {
        this.queryParam.date = dateString
      }
    },
    setCurrentPage () {
      const page = this.$store.getters.pop
      if (page) {
        console.log('获取到的page：', page)
        const current = page.split('#$$#')[0]
        const query = page.split('#$$#')[1]
        const path = page.split('#$$#')[2]
        sessionStorage.removeItem('GuaranteeCurrentPage')
        if (path === this.$route.path) {
          if (!isNaN(Number(current))) {
            this.pageNum = Number(current)
          }
          if (query) {
            this.queryParam = JSON.parse(query)
          }
        } else {
          this.queryParam = {}
          this.$store.dispatch('clear')
        }
      } else {
        console.log('这是个空的page')
      }
    },
    openPreview (url) {
      if (url === undefined || url === '') {
        this.$message.warning('飞机图片不存在')
        return
      }
      this.previewVisible = true
      this.previewUrl = url
    }
  }
}
</script>
